<template>
  <d-modal :show-close="false" @close="close">
    <div class="d-modal" slot="insertComponent" style="width: 400px">
      <div class="d-modal__header" :style="{'background': firstInSubjectsWithSameName.color}">
        <h2 style="color: #ffffff">"<b>{{ firstInSubjectsWithSameName.name }}</b>" {{ i18n[locale]['exists'] }}</h2>
        <div class="d-modal__close icon__bg-circle" style="color: #ffffff" @click="close">
          <span class="icon-cross2"></span>
        </div>
      </div>
      <div class="d-modal__content">
        <p>{{ i18n[locale]['the_subject'] }}: "<b>{{ firstInSubjectsWithSameName.name }}</b>" <span>{{ i18n[locale]['already_exists'] }}</span></p>
        <h4 class="marg-1-top" v-if="subjectsCanBeDeleted.length > 0">{{ i18n[locale]['do_you_want_to_delete'] }}?</h4>
        <table class="klassesWithSubjects">
          <tr v-for="subject in subjectsCanBeDeletedWithVProps" :key="subject.id">
            <td>{{ subject.v_calendar_name }} </td>
            <td>
              <div class="d-subject" :style="{'background': subject.color}">{{ subject.name }} ({{
                subject.hours
                }})</div>
            </td>
          </tr>
        </table>
        <p class="bold italic marg-1-top text-danger" v-if="subjectsCannotDelete.length > 0">{{ i18n[locale]['subject_cannot_be_deleted'] }}</p>
        <table class="klassesWithSubjects">
          <tr v-for="subject in subjectsCannotDeleteWithVProps" :key="subject.id">
            <td>{{ subjectsCannotDelete.v_calendar_name }} </td>
            <td>
              <div class="d-subject d-subject--cannot-delete" :style="{'background': subject.color}">
                {{ subject.name }} ({{ subject.hours }})
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="d-modal__buttons pad-1">
        <button class="bttn marg-1-right" @click="keepExistingSubjects">{{ i18n[locale]['create_new_anyway'] }}</button>
        <button class="bttn submit-button" @click="deleteExistingSubjects" v-if="subjectsCanBeDeleted.length > 0">
          <span class="icon-bin"></span> {{ i18n[locale]['delete'] }}
        </button>
      </div>
    </div>
  </d-modal>
</template>

<script>
import DModal from '../common/DModal'

export default {
  components: {DModal},
  props: {
    subjectsWithSameName: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      locale: 'da',
      i18n: {
        da: {
          exists: 'findes allerede',
          the_subject: 'Faget',
          already_exists: 'findes allerede i klassen/klasserne, du er ved at tilføje på faget.',
          do_you_want_to_delete: 'Vil du slette eksisterende fag',
          create_new_anyway: 'Behold eksisterende',
          delete: 'Slet eksisterende fag',
          subject_cannot_be_deleted: 'Disse fag kan ikke slettes, da de er skemalagt'
        },
        en: {
          exists: 'already exists',
          delete_existing_subjects: 'Delete already existing course',
          the_subject: 'The course',
          already_exists: 'already exists in the grades/groups.',
          do_you_want_to_delete: 'Would you like to delete the already existing course?',
          create_new_anyway: 'Keep existing',
          delete: 'Delete already existing course',
          subject_cannot_be_deleted: 'These courses cannot be deleted, as they contain scheduled activities.'
        },
        nb: {
          exists: 'er allerede opprettet',
          delete_existing_subjects: 'Slett eksisterende fag',
          the_subject: 'Faget',
          already_exists: 'finnes allerede i klassen/klassene du ønsker å legge til.',
          do_you_want_to_delete: 'Vil du slette allerede eksisterende fag',
          create_new_anyway: 'Legg til fag til i klassen allikevel',
          delete: 'Slett eksisterende fag',
          subject_cannot_be_deleted: 'Disse fagene kan ikke slettes, ettersom de inngår i planlagte timer i timeplanene.'
        }
      }
    }
  },
  computed: {
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsCanBeDeleted () {
      return this.subjectsWithSameName.filter(subject => subject.can_delete)
    },
    subjectsCanBeDeletedWithVProps () {
      return this.subjectsCanBeDeleted.map(subject => {
        subject.v_calendar_name = this.allCalendarsInHash[subject.calendar_id] ? this.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id
        return subject
      })
    },
    subjectsCannotDelete () {
      return this.subjectsWithSameName.filter(subject => !subject.can_delete)
    },
    subjectsCannotDeleteWithVProps () {
      return this.subjectsCannotDelete.map(subject => {
        subject.v_calendar_name = this.allCalendarsInHash[subject.calendar_id] ? this.allCalendarsInHash[subject.calendar_id].name : subject.calendar_id
        return subject
      })
    },
    firstInSubjectsWithSameName () {
      return this.subjectsWithSameName[0] ? this.subjectsWithSameName[0] : {name: '', color: ''}
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    keepExistingSubjects () {
      this.$emit('keep')
    },
    deleteExistingSubjects () {
      this.$emit('delete')
    }
  },
  beforeMount () {
    this.locale = window.language ? window.language : 'da'
  }
}
</script>

<style scoped>
.d-subject {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: default;
  padding: 0 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgb(0 0 0 / 30%);
  opacity: 0.9;
  text-align: left;
  width: 230px;
}

.d-subject.d-subject--cannot-delete {
  box-shadow: none;
  opacity: 0.7;
  cursor: not-allowed;
}

.klassesWithSubjects tr > td:first-child {
  padding-right: 1rem;
  min-width: 25px;
}

.klassesWithSubjects tr > td {
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent;
  border-top: 2px solid transparent;
}

</style>



// WEBPACK FOOTER //
// SubjectFormDeleteSubjects.vue?6010df0d